module.exports = __webpack_public_path__ + "img/truck-pink.decd41a8.svg";